export default __webpack_public_path__ + "images/d1e0b371532e3e9f38d831bc4bbef02b-plane-right.png";